import React from 'react';
import { Route } from 'react-router';
import PaperContainer from 'split-chunk-loader?lazy!../Checkout/PreCartUpgrades/PaperContainer';
import AccessoryContainer from 'split-chunk-loader?lazy!../Checkout/PreCartUpgrades/AccessoryContainer';
import { lazify } from '../Common/Helper';

const PreCartUpgradeRoutes = (
    <Route label="Pre-Cart Upgrade"
           path="checkout/precartupgrade">
        <Route 
            label='Paper Upgrade' 
            path='paper/:projectId'
            component={lazify(PaperContainer)}>
        </Route>
        <Route 
            label='Accessory Upgrade'
            path='accessory/:projectId'
            component={lazify(AccessoryContainer)}>
        </Route>
        <Route 
            label='Add On Accessory Upgrade'
            path='addon_accessory/:projectId'
            component={lazify(AccessoryContainer)}>
        </Route>
    </Route>
);
  
export default PreCartUpgradeRoutes;


// WEBPACK FOOTER //
// ./src/Routes/PreCartUpgrade.js